import { createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../gql/api';
import _ from 'lodash';
import { setCurrentWorkspaceBrandsIds } from '../slices/currentWorkspace';
import { setBrands } from '../slices/brands';

export const getBrandsByWorkspace = createAsyncThunk(
  'brands/getBrandsByWorkspace',
  async (payload, { dispatch }) => {
    const {
      workspaceId,
      setLoading = () => {},
      setErrors = () => {},
    } = payload;

    if (!_.isEmpty(workspaceId)) {
      setLoading(true);
      try {
        const brands = await api.workspace.getBrandsByWorkspaceId({
          workspaceId,
        });

        if (brands.data.getBrandsByWorkspaceId?.brands) {
          dispatch(setBrands(brands.data.getBrandsByWorkspaceId.brands));

          dispatch(
            setCurrentWorkspaceBrandsIds(
              brands.data.getBrandsByWorkspaceId.brands.map(
                (brands) => brands.id
              )
            )
          );

          setLoading(false);
          return brands.data.getBrandsByWorkspaceId.brands;
        }
      } catch (error) {
        setErrors(error.message);
        setLoading(false);
        return null;
      }
    } else {
      setErrors('generalError');
      setLoading(false);
      return null;
    }
    return null;
  }
);

export const createBrand = createAsyncThunk(
  'brands/createBrand',
  async (payload) => {
    const newBrand = await api.brands.createBrand({ data: payload });
    return newBrand.data.createBrand;
  }
);

export const updateBrandById = createAsyncThunk(
  'brands/updateBrandById',
  async ({ brandId, data }) => {
    const updatedBrand = await api.brands.updateBrandById({
      id: brandId,
      data,
    });

    return updatedBrand.data.updateBrandById;
  }
);

export const deleteBrandById = createAsyncThunk(
  'brands/deleteBrandById',
  async (brandId) => {
    const deletedBrand = await api.brands.deleteBrandById({
      id: brandId,
    });
    return deletedBrand.data.deleteBrandById;
  }
);
